import React, { useEffect, useState, useCallback } from "react";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, parse, isValid, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Button,
  Text,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";

import DiaHorario from "./DiaHorario";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import DesligarModal from "./Desligar";
import CustomDropzone from "../../../../components/CustomDropzone";
import FileInformation from "../../../../components/FileInformation";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";

import VoluntariadoSAService from "../../../../../main/services/VoluntariadoSAService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { Permission, servicos } from "../../../../../helpers/Funcionalidades";
import { nivelarDias, organizarDias } from "../../../../utils/diaHorarioFilter";

const VisualizarEditarVoluntariadoModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  isEdicao,
  editarVoluntariadoServ,
  setEditarVoluntariadoServ,
  roleKeycloack,
  user,
  idPJ,
}) => {
  const {
    isOpen: isOpenDesligar,
    onOpen: onOpenDesligar,
    onClose: onCloseDesligar,
  } = useDisclosure();

  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [isVisualizacao, setIsVisualizacao] = useState(isEdicao ? false : true);
  const [loading, setLoading] = useState(true);
  const [anexoEditado, setAnexoEditado] = useState(false);
  const [initialValues, setInitialValues] = useState({
    nomeVoluntariado: "",
    voluntariadoAtividades: "",
    dtInicioServico: "",
    dtAssinaturaTermo: "",
    anexo: null,
    anexoTermo: null,
    horarioAtividade: "",
    listaHorarios: "",
    domingo: [{ start: "", end: "" }],
    segunda: [{ start: "", end: "" }],
    terca: [{ start: "", end: "" }],
    quarta: [{ start: "", end: "" }],
    quinta: [{ start: "", end: "" }],
    sexta: [{ start: "", end: "" }],
    sabado: [{ start: "", end: "" }],
  });
  const handleGetVoluntario = useCallback(() => {
    VoluntariadoSAService.getVoluntario(id)
      .then((res) => {
        const {
          horarioAtividade,
          servicoAcolhimento,
          id,
          dtInicioServico,
          dtAssinaturaTermo,
          dtFimServico,
          anexoTermo,
          listaHorarios,
          ...resto
        } = res.data;

        const tempHorarioAtividade = listaHorarios
          ? organizarDias(listaHorarios)
          : "";

        if (!anexoTermo) {
          setAnexoEditado(true);
        }

        setInitialValues({
          ...resto,
          anexoTermo,
          dtInicioServico: dtInicioServico
            ? format(new Date(dtInicioServico), "dd/MM/yyyy")
            : "",
          dtAssinaturaTermo: dtAssinaturaTermo
            ? format(new Date(dtAssinaturaTermo), "dd/MM/yyyy")
            : "",
          anexo: null,
          horarioTrabalho: "",
          domingo:
            tempHorarioAtividade?.domingo.length > 0
              ? tempHorarioAtividade.domingo
              : [{ id: 0, nomeDiaSemana: "domingo", start: "", end: "" }],
          segunda:
            tempHorarioAtividade?.segunda.length > 0
              ? tempHorarioAtividade.segunda
              : [{ id: 0, nomeDiaSemana: "segunda", start: "", end: "" }],
          terca:
            tempHorarioAtividade?.terca.length > 0
              ? tempHorarioAtividade.terca
              : [{ id: 0, nomeDiaSemana: "terca", start: "", end: "" }],
          quarta:
            tempHorarioAtividade?.quarta.length > 0
              ? tempHorarioAtividade.quarta
              : [{ id: 0, nomeDiaSemana: "quarta", start: "", end: "" }],
          quinta:
            tempHorarioAtividade?.quinta.length > 0
              ? tempHorarioAtividade.quinta
              : [{ id: 0, nomeDiaSemana: "quinta", start: "", end: "" }],
          sexta:
            tempHorarioAtividade?.sexta.length > 0
              ? tempHorarioAtividade.sexta
              : [{ id: 0, nomeDiaSemana: "sexta", start: "", end: "" }],
          sabado:
            tempHorarioAtividade?.sabado.length > 0
              ? tempHorarioAtividade.sabado
              : [{ id: 0, nomeDiaSemana: "sabado", start: "", end: "" }],
        });

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          onClose();
        });
      });
  }, [id, setAnexoEditado, setInitialValues, setLoading, onClose]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    handleGetVoluntario();
  }, [handleGetVoluntario]);

  useEffect(() => {
    if (isVisualizacao) {
      handleGetVoluntario();
    }
  }, [isVisualizacao, handleGetVoluntario]);

  const handleVoluntarioDesligado = () => {
    onCloseDesligar();
    onClose();
  };

  const backAlert = () => {
    if (isVisualizacao) {
      onClose();
    } else {
      if (editarVoluntariadoServ) {
        Swal.fire({
          title: "Tem certeza que deseja cancelar?",
          text: "As informações serão perdidas.",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
            setEditarVoluntariadoServ(false);
          }
        });
      } else {
        onClose();
      }
    }
  };

  const schema = Yup.object().shape({
    nomeVoluntariado: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    voluntariadoAtividades: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    dtInicioServico: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    dtAssinaturaTermo: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test(
        "dtAssinaturaTermoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        },
      )
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    listaHorarios: Yup.mixed("Preenchimento obrigatório!").when(
      ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"],
      (domingo, segunda, terca, quarta, quinta, sexta, sabado, schema) => {
        return schema.test(
          "hasValid",
          "Preenchimento obrigatório!",
          (value, context) => {
            let hasValid = false;
            Object.entries({
              domingo,
              segunda,
              terca,
              quarta,
              quinta,
              sexta,
              sabado,
            }).forEach((val) => {
              if (val[1]) {
                val[1].forEach((horario) => {
                  if (!!horario.start && !!horario.end) {
                    hasValid = true;
                  }
                });
              }
            });
            return hasValid;
          },
        );
      },
    ),
    domingo: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    segunda: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    terca: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    quarta: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    quinta: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    sexta: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    sabado: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    anexo: Yup.mixed()
      .test("anexoNrRegistroRequired", "Este campo é obrigatório!", (value) => {
        if (anexoEditado) {
          return value !== null;
        } else {
          return true;
        }
      })
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null || !anexoEditado) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null || !anexoEditado) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        anexo,
        dtInicioServico,
        dtAssinaturaTermo,
        anexoTermo,
        horarioAtividade,
        listaHorarios,
        domingo,
        segunda,
        terca,
        quarta,
        quinta,
        sexta,
        sabado,
        ...resto
      } = values;

      const horarios = {
        domingo,
        segunda,
        terca,
        quarta,
        quinta,
        sexta,
        sabado,
      };

      const valuesToSend = {
        file: anexo,
        dtInicioServico: parse(
          dtInicioServico,
          "dd/MM/yyyy",
          new Date(),
        ).toISOString(),
        dtAssinaturaTermo: parse(
          dtAssinaturaTermo,
          "dd/MM/yyyy",
          new Date(),
        ).toISOString(),
        anexoEditado,
        horarioAtividade: JSON.stringify(horarios),
        ...resto,
        listaHorarios: JSON.stringify(nivelarDias(horarios)),
      };

      VoluntariadoSAService.atualizarVoluntarioSA(id, valuesToSend)
        .then((res) => {
          onClose();
          Swal.fire({
            title: "Sucesso!",
            text: "Registro atualizado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            setEditarVoluntariadoServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "voluntariado") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={backAlert} size="6xl">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#169499"
        >
          {isVisualizacao ? "VISUALIZAR VOLUNTÁRIO" : "EDITAR VOLUNTÁRIO"}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          {!loading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form>
                  {!isVisualizacao &&
                    setEditarVoluntariadoServ(
                      hasFormChanged(initialValues, props.values),
                    )}
                  <Flex flexDir="column">
                    <Grid
                      mt="20px"
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        lg: "repeat(2, 1fr)",
                      }}
                      gap="20px"
                      rowGap="15px"
                    >
                      <GridItem colSpan={1}>
                        <Field name="nomeVoluntariado">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={
                                form.errors.nomeVoluntariado &&
                                form.touched.nomeVoluntariado
                              }
                              id="nomeVoluntariado"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="nomeVoluntariado"
                              >
                                Nome*
                              </FormLabel>
                              <Input
                                {...field}
                                h="42px"
                                name="nomeVoluntariado"
                                id="nomeVoluntariado"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe o Nome"
                                isDisabled={isVisualizacao}
                              />
                              <FormErrorMessage>
                                {form.errors.nomeVoluntariado}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>
                      <GridItem colSpan={1}>
                        <Field name="voluntariadoAtividades">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={
                                form.errors.voluntariadoAtividades &&
                                form.touched.voluntariadoAtividades
                              }
                              id="voluntariadoAtividades"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="voluntariadoAtividades"
                              >
                                Atividades Desenvolvidas*
                              </FormLabel>
                              <Input
                                {...field}
                                h="42px"
                                name="voluntariadoAtividades"
                                id="voluntariadoAtividades"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe as Atividades"
                                isDisabled={isVisualizacao}
                              />
                              <FormErrorMessage>
                                {form.errors.voluntariadoAtividades}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>
                      <GridItem colSpan={1}>
                        <CustomDatepickerWField
                          fieldName="dtInicioServico"
                          label="Início das Atividades no Serviço de Acolhimento*"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisualizacao}
                        />
                      </GridItem>
                      <GridItem colSpan={1}>
                        <CustomDatepickerWField
                          fieldName="dtAssinaturaTermo"
                          label="Data de Assinatura do Termo do Voluntariado*"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisualizacao}
                        />
                      </GridItem>
                    </Grid>

                    <Grid mt="20px" templateColumns={"repeat(7, 1fr) 1fr"}>
                      <GridItem colSpan={{ base: 1, lg: 2 }}>
                        {anexoEditado ? (
                          <CustomDropzone
                            title="Anexar Termo do Voluntariado*"
                            fieldName="anexo"
                            formProps={props}
                            setAnexoNaoEditado={() => {
                              setAnexoEditado(false);
                            }}
                          />
                        ) : (
                          initialValues.anexoTermo && (
                            <FileInformation
                              label="Anexar Termo do Voluntariado*"
                              name={initialValues.anexoTermo.nomeArquivo}
                              path={initialValues.anexoTermo.pathAnexo
                                .toString()
                                .split("/")
                                .pop()}
                              setAnexoEditado={() => {
                                setAnexoEditado(true);
                              }}
                              isVisualizacao={isVisualizacao}
                            />
                          )
                        )}
                      </GridItem>
                    </Grid>

                    <Flex
                      flexDir="column"
                      mt={6}
                      border="1px solid #D7D8DE"
                      borderRadius="base"
                      pl="2"
                    >
                      <Text
                        color="#5F6377"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                        mt="12px"
                      >
                        Horário das Atividades*
                      </Text>
                      <Text
                        color="#e53e3e"
                        fontSize="14px"
                        mt={props.errors.listaHorarios ? "5px" : "0px"}
                      >
                        {props.errors.listaHorarios
                          ? props.errors.listaHorarios
                          : ""}
                      </Text>
                      <DiaHorario
                        fieldName="domingo"
                        title="Domingo:"
                        mt="10px"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="segunda"
                        title="Segunda-feira:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="terca"
                        title="Terça-feira:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="quarta"
                        title="Quarta-feira:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="quinta"
                        title="Quinta-feira:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="sexta"
                        title="Sexta-feira:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                      <DiaHorario
                        fieldName="sabado"
                        title="Sábado:"
                        formProps={props}
                        isVisualizacao={isVisualizacao}
                      />
                    </Flex>

                    <SimpleGrid
                      alignSelf="center"
                      mt="20px"
                      columns={{ base: 1, lg: isVisualizacao ? 3 : 2 }}
                      spacing="15px"
                      w={{ base: "100%", lg: isVisualizacao ? "50%" : "40%" }}
                    >
                      <Button
                        id="button-voltar-modal"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        _hover={{ bg: "#169499" }}
                        onClick={backAlert}
                      >
                        Voltar
                      </Button>
                      {!isVisualizacao && (
                        <Button
                          id="button-salvar-modal"
                          type="submit"
                          translate="no"
                          color="#FFF"
                          backgroundColor="#169499"
                          fontWeight={700}
                          fontSize="15px"
                          lineHeight="21.6px"
                          _hover={{ bg: "#169499" }}
                          isLoading={props.isSubmitting}
                        >
                          Salvar
                        </Button>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.voluntariadoEditar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-editar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={() => {
                              setIsVisualizacao(false);
                            }}
                          >
                            Editar
                          </Button>
                        </Permission>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.voluntariadoDesligar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-desligar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={onOpenDesligar}
                          >
                            Desligar
                          </Button>
                        </Permission>
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          ) : (
            <Flex w="100%" mt="25%" justifyContent="center">
              <LoadingSpinner />
            </Flex>
          )}
          {isOpenDesligar && (
            <DesligarModal
              isOpen={isOpenDesligar}
              onOpen={onOpenDesligar}
              onClose={onCloseDesligar}
              id={id}
              inicioAtividade={initialValues.dtInicioServico}
              handleVoluntarioDesligado={handleVoluntarioDesligado}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VisualizarEditarVoluntariadoModal;
